import { createApp } from 'vue';
import App from './App.vue';

import router from './router';
import axios from 'axios';
import login from './utils/login';

import { DatePicker, Dialog, DialogPlugin, Message, MessagePlugin, Pagination, Table } from 'tdesign-vue-next';
import 'tdesign-vue-next/es/style/index.css';
import PanelFrame from './components/panelFrame.vue';
import EmptyComp from './components/emptyComp.vue';
import PickerComp from './components/pickerComp.vue';
import MultipickerComp from './components/multipickerComp.vue';
import MaskComp from './components/maskComp.vue';
import TableWithPage from './components/tableWithPage.vue';

const app = createApp(App);

init()
app.mount('#app');

function init() {
  app.config.globalProperties.$axios = axios;
  app.config.globalProperties.$login = login;
  const hostname = window.location.hostname;
  if(hostname.includes('localhost')) {
    app.config.globalProperties.$api = 'https://www.srsoa.cn/v1';
    // app.config.globalProperties.$api = 'http://localhost:3001/v1';
  } else {
    app.config.globalProperties.$api = 'https://www.srsoa.cn/v1';
  }
  app.config.globalProperties.$screenWidth = window.innerWidth;

  useComponet();
  getEvents();
}

function useComponet() {
  app.use(router);
  app.use(Message);
  app.use(Pagination);
  app.use(Dialog);
  app.use(DatePicker);
  app.use(Table);

  app.use(MessagePlugin);
  app.use(DialogPlugin);
  // app.use(Icon);

  app.component('panelFrame', PanelFrame);
  app.component('emptyComp', EmptyComp);
  app.component('pickerComp', PickerComp);
  app.component('multipickerComp', MultipickerComp);
  app.component('maskComp', MaskComp);
  app.component('tableWithPage', TableWithPage);
}

function getEvents() {
  axios.get(app.config.globalProperties.$api + '/event').then(res => {
    app.config.globalProperties.$events = res.data.code == 200 ? res.data.items : [];
  });
}